import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  initialize() {
    this.originalExpandText = "Expand";
    this.expanded = false;
    this.expandedClasses = ["fixed", "inset-0", "p-4", "bg-white", "z-20", "overflow-auto"];
  }

  toggle(e) {
    if(this.expanded) {
      this.collapse(e);
    } else {
      this.expand(e);
    }
  }

  expand(e) {
    this.originalExpandText = e.target.innerText;
    e.target.innerText = "Collapse";
    for (var i = 0; i <= this.expandedClasses.length; i++) {
      this.element.classList.add(this.expandedClasses[i]);
    }
    this.expanded = true;
  }

  collapse(e) {
    e.target.innerText = this.originalExpandText;
    for (var i = 0; i <= this.expandedClasses.length; i++) {
      this.element.classList.remove(this.expandedClasses[i]);
    }
   this.expanded = false;
  }
  
}